
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep2 {
  possibleBenefit: string;
}

export default defineComponent({
  name: "step-2",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];
    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    const step2 = ref<IStep2>({
      possibleBenefit: "",
    });

    watchEffect(() => {
      const data = store.getters.currentRisk;
      if (data === null || data.data === undefined) return;
      step2.value.possibleBenefit = data.data.possibleBenefit || "";
    });

    return {
      step2,
      Editor,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
